import React from 'react';
import CloseButton from '../../Buttons/CloseButton';
import './style.scoped.scss';
import '../modals.scss';

const AboutModal = ({
  handleDismiss,
}) => {
  return (
    <div className="modal about" id="aboutModal">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h2>1WordFlow Solutions for Aged Care</h2>
            <CloseButton title="Dismiss Modal" handleClose={handleDismiss} />
          </div>
          <div className="about__content px-3">
            Aged care providers will need to equip their workforce to navigate the changes that new regulations will require.
            <br />
            <br />
            The same technology that transformed the Aged Care Royal Commission Final
            Report into easy to navigate web pages can transform the critical documents that
            Aged Care operators and their workforce need to deliver high quality care.
            <br />
            <br />
            1WordFlow Policies Reimagined automatically transforms policies, procedures and
            regulations into dynamic enriched web pages. Your workforce has instant access to
            up to date policies and procedures at all times - anywhere, on any device and in any language.
            <br />
            <br />
            Watch this short video to see how 1WordFlow can help prepare your organisation now for the regulatory changes ahead.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
